import { pubSub } from '@utils/PubSub';

function updateFromDY(message) {
  const copy = document.querySelector('.pdp-notification__copy');
  if (!copy) return;
  copy.textContent = message;

  initNotification();
}

function listenClose() {
  const notification = document.querySelector('.pdp-notification');
  const close = document.querySelector('.pdp-notification__close');
  if (!notification || !close) return;

  close.addEventListener('click', () => {
    notification.removeAttribute('active', '');
    window.sessionStorage.setItem('pdp-notification-visible', 'false');
  });
}

function initNotification() {
  const notification = document.querySelector('.pdp-notification');
  const notificationVisibility =
    window.sessionStorage.getItem('pdp-notification-visible') ?? 'true';
  const userOptedOut = notificationVisibility === 'false';
  if (!notification || userOptedOut) return;

  const delay = parseInt(notification.dataset.delay);
  setTimeout(() => {
    notification.setAttribute('active', '');
  }, delay);

  listenClose();
}

function mountPdpNotification() {
  pubSub.subscribe(`dy:pdp-tote-popup:init`, () => {
    const message = window.Brooklinen.pdpTotePopup[0].popup_content;
    updateFromDY(message);
    pubSub.unsubscribe(`dy:pdp-tote-popup:init`);
  });

  if (!window.Brooklinen.pdpTotePopup) initNotification();
}

mountPdpNotification();
